import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// recuperer les archives d'un etudiant par son id
export const getStudentArchivesById = async (id_student, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/archive/student/byid/${id_student}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// recuperer les archives d'un etudiant par son id de l'année academique
export const getAllArchiveById = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/archive/student/byYear/${id_academicYear}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// mettre à jour l'inscription d'un étudiant
export const updateStudentRegistration = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/student/updateRegistration/${id}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};
